import { render, staticRenderFns } from "./modalProductoPrecioSugerido.vue?vue&type=template&id=520e8c78&scoped=true&"
import script from "./modalProductoPrecioSugerido.vue?vue&type=script&lang=js&"
export * from "./modalProductoPrecioSugerido.vue?vue&type=script&lang=js&"
import style0 from "./modalProductoPrecioSugerido.vue?vue&type=style&index=0&id=520e8c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e8c78",
  null
  
)

export default component.exports